<script type="text/javascript">
    import Tabs from '@/components/UI/Tabs/Tabs.vue';

    export default {
        Tabs,
    }
</script>